import { render, staticRenderFns } from "./ReviewComponent.vue?vue&type=template&id=582b0269&scoped=true&"
import script from "./ReviewComponent.vue?vue&type=script&lang=js&"
export * from "./ReviewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582b0269",
  null
  
)

export default component.exports